import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import DomToImage from 'dom-to-image';
import { Deferred } from '../classes/deferred';
import { Callout } from '../classes/models/callout.model';
import { util } from '../classes/util';
import { environment } from '../environment';
import { ESRI } from '../esri-loader-util';
import { isFeatureLayer, isGraphicsLayer, isGroupLayer, isMapImageLayer, isSimpleRenderer, isSymbolWithOutline, isSymbolWithWidth, isTextSymbol } from '../types';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var Graphic;
var SymbolUtils;
var blankLegendString = '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';
var maxRowsHeight = 40;
var lineWidthMultiplyer = 2;
var legendSizeMap = {
    '11x8.5': {
        heightInches: 0.7803,
        widthInches: 6.827,
        maxRows: 3
    },
    '8.5x11': {
        heightInches: 1.513,
        widthInches: 4.8704,
        maxRows: 5
    },
    '17x11': {
        heightInches: 0.8,
        widthInches: 13.0767,
        maxRows: 3
    },
    '11x17': {
        heightInches: 1.5,
        widthInches: 7.3264,
        maxRows: 4
    },
    '22x17': {
        heightInches: 0.8159,
        widthInches: 18.3609,
        maxRows: 2
    },
    '17x22': {
        heightInches: 1.5024,
        widthInches: 13.3552,
        maxRows: 4
    },
    '34x22': {
        heightInches: 0.8821,
        widthInches: 30.0557,
        maxRows: 2
    },
    '22x34': {
        heightInches: 1.5582,
        widthInches: 18.265,
        maxRows: 4
    },
    '44x34': {
        heightInches: 0.7918,
        widthInches: 40.222,
        maxRows: 3
    },
    '34x44': {
        heightInches: 1.5514,
        widthInches: 30.3608,
        maxRows: 3
    }
};
var layoutSizeMap = {
    '11x8.5': {
        heightInches: 6.0953,
        widthInches: 9.7527,
        drawingScale: 1.2,
        textScale: 1.1,
        textOffsetMultiplier: 3
    },
    '8.5x11': {
        heightInches: 8,
        widthInches: 7.5,
        drawingScale: 1.2,
        textScale: 1.1,
        textOffsetMultiplier: 3
    },
    '17x11': {
        heightInches: 9,
        widthInches: 16,
        drawingScale: 0.8,
        textScale: 0.9,
        textOffsetMultiplier: 3.5
    },
    '11x17': {
        heightInches: 14.125,
        widthInches: 10,
        drawingScale: 0.8,
        textScale: 0.9,
        textOffsetMultiplier: 3.5
    },
    '22x17': {
        heightInches: 14.75,
        widthInches: 21.0004,
        drawingScale: 0.6,
        textScale: 0.7,
        textOffsetMultiplier: 4.5
    },
    '17x22': {
        heightInches: 18.875,
        widthInches: 16,
        drawingScale: 0.6,
        textScale: 0.7,
        textOffsetMultiplier: 4.5
    },
    '34x22': {
        heightInches: 19.25,
        widthInches: 33,
        drawingScale: 0.3,
        textScale: 0.4,
        textOffsetMultiplier: 7.5
    },
    '22x34': {
        heightInches: 30.5,
        widthInches: 21,
        drawingScale: 0.3,
        textScale: 0.4,
        textOffsetMultiplier: 7.5
    },
    '44x34': {
        heightInches: 30.75,
        widthInches: 43,
        drawingScale: 0.1,
        textScale: 0.3,
        textOffsetMultiplier: 14
    },
    '34x44': {
        heightInches: 40.5,
        widthInches: 33.0242,
        drawingScale: 0.1,
        textScale: 0.3,
        textOffsetMultiplier: 14
    }
};
var layoutRegex = new RegExp(/(\d+\.*\d*)x(\d+\.*\d*)/);
/**
 * Maps line styles only available client-side and their nearest equivalents for printing.
 */
var clientSideOnlyLineStyleMap = {
    esriSLSLongDash: 'esriSLSDash',
    esriSLSLongDashDot: 'esriSLSDashDot',
    esriSLSLongDashDotDot: 'esriSLSDashDot',
    esriSLSShortDash: 'esriSLSDash',
    esriSLSShortDashDot: 'esriSLSDashDot',
    esriSLSShortDashDotDot: 'esriSLSDashDot',
    esriSLSShortDot: 'esriSLSDot',
    'long-dash': 'dash',
    'long-dash-dot': 'dash-dot',
    'long-dash-dot-dot': 'dash-dot',
    'short-dash': 'dash',
    'short-dash-dot': 'dash-dot',
    'short-dash-dot-dot': 'dash-dot',
    'short-dot': 'dot'
};
var PrintService = /** @class */ (function () {
    function PrintService(http) {
        this.http = http;
        /**
         * Layout URL from config
         */
        this.serviceUrl = environment.apiBaseUrl + '/arcgis/print';
        this.heatmapImageData = { imageData: '', layerid: '', extent: null };
    }
    PrintService.prototype.setupDefaultPrintBasemap = function (defaultPrintTemplate, mapView) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, Basemap, MapImageLayer, basemap, printBasemapUrl, basemapLayer;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([ESRI.Basemap, ESRI.MapImageLayer])];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 2]), Basemap = _a[0], MapImageLayer = _a[1];
                        if (!defaultPrintTemplate.basemap) return [3 /*break*/, 3];
                        basemap = Basemap.fromId(defaultPrintTemplate.basemap);
                        mapView.map.set('basemap', basemap);
                        return [4 /*yield*/, basemap.when()];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        printBasemapUrl = environment.pennDotPrintBaseMapUrl;
                        basemapLayer = new MapImageLayer({ url: printBasemapUrl, legendEnabled: false });
                        basemapLayer.mapcoreProps = { hideInLegend: true };
                        mapView.map.layers.add(basemapLayer);
                        mapView.map.reorder(basemapLayer, 0);
                        return [4 /*yield*/, basemapLayer.when()];
                    case 4:
                        _b.sent();
                        return [2 /*return*/, basemapLayer];
                    case 5: return [2 /*return*/, null];
                }
            });
        });
    };
    PrintService.prototype.loadLayouts = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var layouts, result, data, container, i, template, match, layoutSize, layout, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        layouts = [];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.http.request('GET', this.serviceUrl + '?f=json').toPromise()];
                    case 2:
                        result = _a.sent();
                        data = result;
                        container = data.parameters.filter(function (x) { return x.name === 'Layout_Template'; })[0];
                        for (i = 0; i < container.choiceList.length; i++) {
                            template = container.choiceList[i];
                            match = layoutRegex.exec(template);
                            layoutSize = layoutSizeMap[match[0]];
                            layout = {
                                name: template,
                                id: i + 1,
                                widthInches: layoutSize.widthInches,
                                heightInches: layoutSize.heightInches
                            };
                            layouts.push(layout);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, layouts];
                }
            });
        });
    };
    PrintService.prototype.validateServerSideLayerStyle = function (lineStyle) {
        return !(lineStyle in clientSideOnlyLineStyleMap);
    };
    /**
     * Returns a list of layers
     * @param mapView The map view to validate.
     */
    PrintService.prototype.validateServerSideLayerStyles = function (layers) {
        var e_1, _a, e_2, _b;
        var invalidLayers = [];
        try {
            for (var layers_1 = tslib_1.__values(layers), layers_1_1 = layers_1.next(); !layers_1_1.done; layers_1_1 = layers_1.next()) {
                var layer = layers_1_1.value;
                if (isFeatureLayer(layer) && isSimpleRenderer(layer.renderer)) {
                    var lineStyle = void 0;
                    if (isSymbolWithWidth(layer.renderer.symbol)) {
                        lineStyle = layer.renderer.symbol.style;
                    }
                    else if (isSymbolWithOutline(layer.renderer.symbol)) {
                        lineStyle = layer.renderer.symbol.outline.style;
                    }
                    if (lineStyle && lineStyle in clientSideOnlyLineStyleMap) {
                        invalidLayers.push(layer);
                    }
                }
                else if (isGraphicsLayer(layer)) {
                    try {
                        for (var _c = tslib_1.__values(layer.graphics), _d = _c.next(); !_d.done; _d = _c.next()) {
                            var graphic = _d.value;
                            if (isSymbolWithOutline(graphic.symbol) && graphic.symbol.outline.style in clientSideOnlyLineStyleMap
                                || isSymbolWithWidth(graphic.symbol) && graphic.symbol.style in clientSideOnlyLineStyleMap) {
                                invalidLayers.push(layer);
                                break;
                            }
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (layers_1_1 && !layers_1_1.done && (_a = layers_1.return)) _a.call(layers_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return invalidLayers;
    };
    PrintService.prototype.getSupportedLineStyle = function (lineStyle) {
        return clientSideOnlyLineStyleMap[lineStyle];
    };
    PrintService.prototype.replaceClientSideOnlyLineStyle = function (symbol) {
        if (symbol.style in clientSideOnlyLineStyleMap) {
            symbol.style = clientSideOnlyLineStyleMap[symbol.style];
        }
        if (symbol.outline && symbol.outline.style in clientSideOnlyLineStyleMap) {
            symbol.outline.style = clientSideOnlyLineStyleMap[symbol.outline.style];
        }
    };
    PrintService.prototype.replaceClientSideOnlyLineStyles = function (layer) {
        var e_3, _a, e_4, _b;
        var symbol = layer && layer.layerDefinition && layer.layerDefinition.drawingInfo && layer.layerDefinition.drawingInfo.renderer && layer.layerDefinition.drawingInfo.renderer.symbol;
        if (symbol) {
            this.replaceClientSideOnlyLineStyle(symbol);
        }
        else if (layer.featureCollection) {
            try {
                for (var _c = tslib_1.__values(layer.featureCollection.layers), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var subLayer = _d.value;
                    try {
                        for (var _e = tslib_1.__values(subLayer.featureSet.features), _f = _e.next(); !_f.done; _f = _e.next()) {
                            var feature = _f.value;
                            this.replaceClientSideOnlyLineStyle(feature.symbol);
                        }
                    }
                    catch (e_4_1) { e_4 = { error: e_4_1 }; }
                    finally {
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        }
                        finally { if (e_4) throw e_4.error; }
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
    };
    /**
     * Generates a pdf or image of a map. Resolves with the url to the result
     */
    PrintService.prototype.printMap = function (mapView, defaultPrintTemplate, extent, includeLegend, emailParams, scaleDrawingLayers, useMapViewBasemap, hasRoutingDetails) {
        if (scaleDrawingLayers === void 0) { scaleDrawingLayers = false; }
        if (useMapViewBasemap === void 0) { useMapViewBasemap = false; }
        if (hasRoutingDetails === void 0) { hasRoutingDetails = false; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, layers, legendImageBase64, legendElement, container, templateName, layoutMapSizeValues, drawingScale, textDrawingScale, originalDrawingLayerSizes, originalBasemap, basemapLayer, heatmapLayers, options, screenshot, routingDetailData, Print, PrintParameters, PrintTemplate, url;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        layers = this.replaceGroupLayers(mapView.map.layers.toArray().reverse());
                        legendImageBase64 = blankLegendString;
                        if (!includeLegend) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.buildLegendElement(defaultPrintTemplate, layers)];
                    case 1:
                        legendElement = _b.sent();
                        container = this.createLegendContainer(legendElement);
                        return [4 /*yield*/, DomToImage.toPng(legendElement, { bgcolor: 'white' })];
                    case 2:
                        legendImageBase64 = _b.sent();
                        legendImageBase64 = legendImageBase64.replace('data:image/png;base64,', ''); // Python print service requires just the base64 text
                        container.remove();
                        _b.label = 3;
                    case 3:
                        templateName = defaultPrintTemplate.selectedLayout.name.split('(').pop().split(')')[0];
                        layoutMapSizeValues = layoutSizeMap[templateName];
                        drawingScale = (Math.ceil((extent.width > extent.height ? extent.width / mapView.extent.width : extent.height / mapView.extent.height) * 100) / 100) * layoutMapSizeValues.drawingScale;
                        textDrawingScale = (Math.ceil((extent.width > extent.height ? extent.width / mapView.extent.width : extent.height / mapView.extent.height) * 100) / 100) * layoutMapSizeValues.textScale;
                        originalDrawingLayerSizes = [];
                        if (scaleDrawingLayers) {
                            originalDrawingLayerSizes = this.scaleDrawingLayers(mapView.map, drawingScale, textDrawingScale, layoutMapSizeValues.textOffsetMultiplier);
                        }
                        else {
                            originalDrawingLayerSizes = this.scaleCalloutBoxes(mapView.map, textDrawingScale, layoutMapSizeValues.textOffsetMultiplier);
                        }
                        this.swapLayerFieldsProperty(mapView.map, 'fields', '_fields');
                        originalBasemap = mapView.map.basemap;
                        if (!!useMapViewBasemap) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.setupDefaultPrintBasemap(defaultPrintTemplate, mapView)];
                    case 4:
                        basemapLayer = _b.sent();
                        _b.label = 5;
                    case 5:
                        heatmapLayers = [];
                        this.heatmapImageData = { imageData: '', layerid: '', extent: null };
                        mapView.map.allLayers.forEach(function (layer) {
                            // check if the renderer is a HeatmapRenderer and is visible
                            if (layer.type === 'feature' && layer.visible && layer.renderer && layer.renderer.type === 'heatmap') {
                                _this.heatmapImageData.layerid = layer.id;
                                _this.heatmapImageData.extent = mapView.extent;
                                heatmapLayers.push(layer);
                            }
                        });
                        if (!(heatmapLayers && heatmapLayers.length && heatmapLayers.length > 0)) return [3 /*break*/, 7];
                        options = {
                            format: 'png',
                            quality: 100,
                            layers: heatmapLayers,
                            ignoreBackground: true
                        };
                        return [4 /*yield*/, mapView.takeScreenshot(options)];
                    case 6:
                        screenshot = _b.sent();
                        this.heatmapImageData.imageData = screenshot.dataUrl.substr(screenshot.dataUrl.indexOf(',') + 1);
                        _b.label = 7;
                    case 7:
                        routingDetailData = { layers: [] };
                        if (hasRoutingDetails && defaultPrintTemplate.format === 'pdf') {
                            mapView.map.allLayers.forEach(function (layer) {
                                // check if the layer has routing details, is visible, and checked in print catalog to be shown
                                if (layer.type === 'graphics' && layer.visible && layer.mapcoreProps && layer.mapcoreProps.routingDetail && layer.mapcoreProps.printRoutingDetail) {
                                    routingDetailData.layers.push({
                                        layerId: layer.id,
                                        layerTitle: layer.mapcoreProps.name,
                                        routingDetail: layer.mapcoreProps.routingDetail
                                    });
                                }
                            });
                        }
                        return [4 /*yield*/, this.setupPrintExecuteInterceptor(layers, extent, basemapLayer ? basemapLayer.id : null, routingDetailData)];
                    case 8:
                        _b.sent();
                        return [4 /*yield*/, Promise.all([ESRI.Print, ESRI.PrintParameters, ESRI.PrintTemplate])];
                    case 9:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 3]), Print = _a[0], PrintParameters = _a[1], PrintTemplate = _a[2];
                        url = Print.execute(this.serviceUrl, new PrintParameters({
                            view: mapView,
                            template: new PrintTemplate({
                                format: defaultPrintTemplate.format,
                                layout: defaultPrintTemplate.selectedLayout.name,
                                layoutOptions: defaultPrintTemplate.layoutOptions,
                                exportOptions: defaultPrintTemplate.exportOptions
                            }),
                            extraParameters: {
                                ExtentJson: JSON.stringify(extent.toJSON()),
                                LegendImageBase64: legendImageBase64,
                                EmailParamsJson: emailParams ? JSON.stringify(emailParams) : undefined
                            }
                        }), { timeout: environment.printTimeout }).then(function (result) {
                            return result.url;
                        });
                        return [4 /*yield*/, this.printExecutePromise];
                    case 10:
                        _b.sent();
                        this.swapLayerFieldsProperty(mapView.map, '_fields', 'fields');
                        if (originalDrawingLayerSizes.length > 0) {
                            this.resetDrawingLayers(originalDrawingLayerSizes);
                        }
                        if (!useMapViewBasemap) {
                            mapView.map.basemap.set('basemap', originalBasemap);
                            if (basemapLayer) {
                                mapView.map.layers.remove(basemapLayer);
                            }
                        }
                        return [4 /*yield*/, url];
                    case 11: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    PrintService.prototype.replaceGroupLayers = function (layers) {
        var e_5, _a;
        var retVal = [];
        var _loop_1 = function (layer) {
            if (isGroupLayer(layer)) {
                layer.layers.forEach(function (l) { return l.mapcoreProps.showInPrintLegend = layer.mapcoreProps.showInPrintLegend; });
                retVal.push.apply(retVal, tslib_1.__spread(layer.layers));
            }
            else {
                retVal.push(layer);
            }
        };
        try {
            for (var layers_2 = tslib_1.__values(layers), layers_2_1 = layers_2.next(); !layers_2_1.done; layers_2_1 = layers_2.next()) {
                var layer = layers_2_1.value;
                _loop_1(layer);
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (layers_2_1 && !layers_2_1.done && (_a = layers_2.return)) _a.call(layers_2);
            }
            finally { if (e_5) throw e_5.error; }
        }
        return retVal;
    };
    PrintService.prototype.createLegendContainer = function (legendElement) {
        var container = document.createElement('div');
        container.style.position = 'absolute';
        container.style.left = '-9999px';
        container.appendChild(legendElement);
        document.body.appendChild(container);
        return container;
    };
    PrintService.prototype.buildLegendElement = function (template, layers) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, e_6, _b, retEl, layers_3, layers_3_1, layer, _c, _d, _e, _f, e_6_1;
            return tslib_1.__generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        retEl = document.createElement('div');
                        if (template && template.selectedLayout) {
                            this.setLegendStyles(retEl, template.selectedLayout, template.exportOptions.dpi);
                        }
                        if (!(layers && layers.length)) return [3 /*break*/, 9];
                        return [4 /*yield*/, Promise.all([ESRI.SymbolUtils, ESRI.Graphic])];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_g.sent(), 2]), SymbolUtils = _a[0], Graphic = _a[1];
                        _g.label = 2;
                    case 2:
                        _g.trys.push([2, 7, 8, 9]);
                        layers_3 = tslib_1.__values(layers), layers_3_1 = layers_3.next();
                        _g.label = 3;
                    case 3:
                        if (!!layers_3_1.done) return [3 /*break*/, 6];
                        layer = layers_3_1.value;
                        if (!(layer.visible && !layer.mapcoreProps.hideInLegend && layer.mapcoreProps.showInPrintLegend)) return [3 /*break*/, 5];
                        _d = (_c = retEl).append;
                        _e = this.buildLayerContainer;
                        _f = [layer];
                        return [4 /*yield*/, this.getSymbolPreviewElements(layer)];
                    case 4:
                        _d.apply(_c, [_e.apply(this, _f.concat([(_g.sent())]))]);
                        _g.label = 5;
                    case 5:
                        layers_3_1 = layers_3.next();
                        return [3 /*break*/, 3];
                    case 6: return [3 /*break*/, 9];
                    case 7:
                        e_6_1 = _g.sent();
                        e_6 = { error: e_6_1 };
                        return [3 /*break*/, 9];
                    case 8:
                        try {
                            if (layers_3_1 && !layers_3_1.done && (_b = layers_3.return)) _b.call(layers_3);
                        }
                        finally { if (e_6) throw e_6.error; }
                        return [7 /*endfinally*/];
                    case 9: return [2 /*return*/, retEl];
                }
            });
        });
    };
    PrintService.prototype.setLegendStyles = function (element, layout, dpi) {
        var pixelDimensions = { width: 100, height: 100, maxRows: 2 };
        var match = layoutRegex.exec(layout.name);
        var legendSize = legendSizeMap[match[0]];
        if (legendSize) {
            pixelDimensions.width = legendSize.widthInches * dpi;
            pixelDimensions.height = legendSize.heightInches * dpi;
            pixelDimensions.maxRows = legendSize.maxRows;
        }
        var scale = Math.ceil(pixelDimensions.height) / (pixelDimensions.maxRows * maxRowsHeight);
        element.style.width = pixelDimensions.width / scale + "px";
        element.style.height = pixelDimensions.height / scale + "px";
        element.style.display = 'flex';
        element.style.flexWrap = 'wrap';
        element.style.fontFamily = 'sans-serif';
        element.style.fontSize = '14px';
    };
    /* tslint:disable:cyclomatic-complexity */
    PrintService.prototype.getSymbolPreviewElements = function (layer) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_7, _a, e_8, _b, e_9, _c, e_10, _d, e_11, _e, symbolPreviewElements, renderers, _f, _g, sublayer, renderer, symbol, _h, _j, renderer, previewPromises, renderers_1, renderers_1_1, renderer, colors, symbols, isClassBreak, _k, _l, classBreak, _m, _o, classBreak, symbols_1, symbols_1_1, symbol, heatmapColors, _p, _q, _r;
            return tslib_1.__generator(this, function (_s) {
                switch (_s.label) {
                    case 0:
                        symbolPreviewElements = [];
                        renderers = [];
                        if (!isMapImageLayer(layer)) return [3 /*break*/, 1];
                        try {
                            for (_f = tslib_1.__values(layer.sublayers.toArray()), _g = _f.next(); !_g.done; _g = _f.next()) {
                                sublayer = _g.value;
                                if (sublayer.renderer) {
                                    renderer = util.deepClone(sublayer.renderer);
                                    if (renderer && renderer.symbol) {
                                        renderer.symbol = this.updateSymbolWithOpacity(renderer.symbol, layer.opacity);
                                        this.sanitizeLineStyleForPrinting(renderer.symbol);
                                    }
                                    renderers.push(renderer);
                                }
                            }
                        }
                        catch (e_7_1) { e_7 = { error: e_7_1 }; }
                        finally {
                            try {
                                if (_g && !_g.done && (_a = _f.return)) _a.call(_f);
                            }
                            finally { if (e_7) throw e_7.error; }
                        }
                        return [3 /*break*/, 4];
                    case 1:
                        if (!isGraphicsLayer(layer)) return [3 /*break*/, 3];
                        symbol = void 0;
                        if (layer.mapcoreProps && layer.mapcoreProps.symbol) {
                            symbol = new Graphic({ symbol: JSON.parse(layer.mapcoreProps.symbol) }).symbol;
                        }
                        else if (layer.graphics && layer.graphics.length) {
                            symbol = layer.graphics.clone().getItemAt(layer.graphics.length - 1).symbol;
                        }
                        if (isTextSymbol(symbol)) {
                            symbol.text = 'Text';
                        }
                        symbol = this.updateSymbolWithOpacity(symbol, layer.opacity ? layer.opacity : 1);
                        this.sanitizeLineStyleForPrinting(symbol);
                        _j = (_h = symbolPreviewElements).push;
                        return [4 /*yield*/, SymbolUtils.renderPreviewHTML(symbol, { maxSize: 12, scale: true })];
                    case 2:
                        _j.apply(_h, [_s.sent()]);
                        return [3 /*break*/, 4];
                    case 3:
                        if (layer.type !== 'group' && layer.type !== 'base-dynamic' && !isGraphicsLayer(layer) && layer.renderer) {
                            renderer = util.deepClone(layer.renderer);
                            if (renderer && renderer.symbol) {
                                renderer.symbol = this.updateSymbolWithOpacity(renderer.symbol, layer.opacity);
                                this.sanitizeLineStyleForPrinting(renderer.symbol);
                            }
                            renderers.push(renderer);
                        }
                        _s.label = 4;
                    case 4:
                        if (!renderers.length) return [3 /*break*/, 6];
                        previewPromises = [];
                        try {
                            for (renderers_1 = tslib_1.__values(renderers), renderers_1_1 = renderers_1.next(); !renderers_1_1.done; renderers_1_1 = renderers_1.next()) {
                                renderer = renderers_1_1.value;
                                switch (renderer.type) {
                                    case 'class-breaks':
                                    case 'unique-value':
                                        colors = [];
                                        symbols = [];
                                        isClassBreak = renderer.type === 'class-breaks';
                                        if (isClassBreak) {
                                            try {
                                                for (_k = tslib_1.__values(renderer.classBreakInfos), _l = _k.next(); !_l.done; _l = _k.next()) {
                                                    classBreak = _l.value;
                                                    colors.push(classBreak.symbol.color);
                                                }
                                            }
                                            catch (e_9_1) { e_9 = { error: e_9_1 }; }
                                            finally {
                                                try {
                                                    if (_l && !_l.done && (_c = _k.return)) _c.call(_k);
                                                }
                                                finally { if (e_9) throw e_9.error; }
                                            }
                                        }
                                        else {
                                            try {
                                                for (_m = tslib_1.__values(renderer.uniqueValueInfos), _o = _m.next(); !_o.done; _o = _m.next()) {
                                                    classBreak = _o.value;
                                                    if (classBreak.symbol.color) {
                                                        colors.push(classBreak.symbol.color);
                                                    }
                                                    else {
                                                        symbols.push(classBreak.symbol);
                                                    }
                                                }
                                            }
                                            catch (e_10_1) { e_10 = { error: e_10_1 }; }
                                            finally {
                                                try {
                                                    if (_o && !_o.done && (_d = _m.return)) _d.call(_m);
                                                }
                                                finally { if (e_10) throw e_10.error; }
                                            }
                                        }
                                        colors = colors.filter(function (c) { return c; });
                                        if (colors.length) {
                                            previewPromises.push(Promise.resolve(SymbolUtils.renderColorRampPreviewHTML(colors.reverse(), { gradient: isClassBreak ? true : false, height: 24, width: 24 })));
                                        }
                                        else if (symbols.length) {
                                            try {
                                                for (symbols_1 = tslib_1.__values(symbols), symbols_1_1 = symbols_1.next(); !symbols_1_1.done; symbols_1_1 = symbols_1.next()) {
                                                    symbol = symbols_1_1.value;
                                                    previewPromises.push(SymbolUtils.renderPreviewHTML(symbol, { maxSize: 14, scale: true }));
                                                }
                                            }
                                            catch (e_11_1) { e_11 = { error: e_11_1 }; }
                                            finally {
                                                try {
                                                    if (symbols_1_1 && !symbols_1_1.done && (_e = symbols_1.return)) _e.call(symbols_1);
                                                }
                                                finally { if (e_11) throw e_11.error; }
                                            }
                                        }
                                        break;
                                    case 'heatmap':
                                        heatmapColors = renderer.colorStops.map(function (x) { return x.color; }).slice(1);
                                        previewPromises.push(Promise.resolve(SymbolUtils.renderColorRampPreviewHTML(heatmapColors, { align: 'horizontal', gradient: true, height: 24, width: 24 })));
                                        break;
                                    default:
                                        previewPromises.push(SymbolUtils.renderPreviewHTML(renderer.symbol, { maxSize: 14, scale: true }));
                                        break;
                                }
                            }
                        }
                        catch (e_8_1) { e_8 = { error: e_8_1 }; }
                        finally {
                            try {
                                if (renderers_1_1 && !renderers_1_1.done && (_b = renderers_1.return)) _b.call(renderers_1);
                            }
                            finally { if (e_8) throw e_8.error; }
                        }
                        _q = (_p = symbolPreviewElements.push).apply;
                        _r = [symbolPreviewElements];
                        return [4 /*yield*/, Promise.all(previewPromises)];
                    case 5:
                        _q.apply(_p, _r.concat([tslib_1.__spread.apply(void 0, [(_s.sent())])]));
                        _s.label = 6;
                    case 6: return [2 /*return*/, symbolPreviewElements];
                }
            });
        });
    };
    PrintService.prototype.updateSymbolWithOpacity = function (symbol, opacity) {
        if (symbol && symbol.color) {
            symbol.color.a *= opacity;
        }
        if (symbol && symbol.outline && symbol.outline.color) {
            symbol.outline.color.a *= opacity;
        }
        return symbol;
    };
    PrintService.prototype.sanitizeLineStyleForPrinting = function (symbol) {
        if (!symbol) {
            return;
        }
        if (isSymbolWithWidth(symbol) && symbol.style in clientSideOnlyLineStyleMap) {
            symbol.style = clientSideOnlyLineStyleMap[symbol.style];
        }
        if (isSymbolWithOutline(symbol)) {
            if (symbol.outline.style in clientSideOnlyLineStyleMap) {
                symbol.outline.style = clientSideOnlyLineStyleMap[symbol.outline.style];
            }
        }
    };
    /* tslint:enable:cyclomatic-complexity */
    PrintService.prototype.buildLayerContainer = function (layer, symbolPreviewElements) {
        var retVal = document.createElement('div');
        retVal.style.flex = '1 1 200px';
        var symbolContainer = document.createElement('div');
        symbolContainer.style.display = 'inline-block';
        symbolContainer.style.verticalAlign = 'middle';
        symbolContainer.style.width = '40px';
        symbolContainer.style.padding = '2px 5px';
        symbolContainer.append.apply(symbolContainer, tslib_1.__spread(symbolPreviewElements));
        retVal.append(symbolContainer);
        var titleContainer = document.createElement('div');
        titleContainer.style.display = 'inline-block';
        titleContainer.style.verticalAlign = 'middle';
        symbolContainer.style.padding = '2px 5px';
        symbolContainer.style.overflow = 'hidden';
        symbolContainer.style.maxHeight = '38px';
        symbolContainer.style.maxWidth = 'calc(100% - 60px)';
        titleContainer.innerText = layer.mapcoreProps.name || layer.title;
        retVal.append(titleContainer);
        return retVal;
    };
    /**
     * Swap the field property in layers before/after printing. (Work-around to get these layers to print.)
     */
    PrintService.prototype.swapLayerFieldsProperty = function (map, sourceProperty, destProperty) {
        var e_12, _a;
        if (map._layers) {
            try {
                for (var _b = tslib_1.__values(map._layers), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var layerId = _c.value;
                    var layer = map._layers[layerId];
                    if (layer[sourceProperty]) {
                        layer[destProperty] = layer[sourceProperty];
                        layer[sourceProperty] = undefined;
                    }
                }
            }
            catch (e_12_1) { e_12 = { error: e_12_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_12) throw e_12.error; }
            }
        }
    };
    PrintService.prototype.scaleDrawingLayers = function (map, scale, textScale, textOffsetMultiplier) {
        var e_13, _a, e_14, _b;
        var retVal = [];
        var graphicsLayers = map.layers.filter(function (layer) { return layer.type === 'graphics'; }).toArray();
        try {
            for (var graphicsLayers_1 = tslib_1.__values(graphicsLayers), graphicsLayers_1_1 = graphicsLayers_1.next(); !graphicsLayers_1_1.done; graphicsLayers_1_1 = graphicsLayers_1.next()) {
                var graphicLayer = graphicsLayers_1_1.value;
                var originalSymbols = { layerId: graphicLayer.id, toReset: [] };
                var layer = map.findLayerById(graphicLayer.id);
                try {
                    for (var _c = tslib_1.__values(layer.graphics.toArray()), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var graphic = _d.value;
                        var symbol = graphic.symbol;
                        originalSymbols.toReset.push({ symbol: { type: symbol.type, json: symbol.toJSON() }, graphic: graphic });
                        this.scaleSymbol(symbol, scale, textScale, textOffsetMultiplier);
                    }
                }
                catch (e_14_1) { e_14 = { error: e_14_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    }
                    finally { if (e_14) throw e_14.error; }
                }
                retVal.push(originalSymbols);
            }
        }
        catch (e_13_1) { e_13 = { error: e_13_1 }; }
        finally {
            try {
                if (graphicsLayers_1_1 && !graphicsLayers_1_1.done && (_a = graphicsLayers_1.return)) _a.call(graphicsLayers_1);
            }
            finally { if (e_13) throw e_13.error; }
        }
        return retVal;
    };
    PrintService.prototype.scaleCalloutBoxes = function (map, textScale, textOffsetMultiplier) {
        var e_15, _a;
        var retVal = [];
        var callouts = Callout.fromLayers(map.layers.filter(function (layer) { return layer.type === 'graphics'; }).map(function (layer) { return layer; }).toArray());
        try {
            for (var callouts_1 = tslib_1.__values(callouts), callouts_1_1 = callouts_1.next(); !callouts_1_1.done; callouts_1_1 = callouts_1.next()) {
                var callout = callouts_1_1.value;
                var originalSymbols = { layerId: callout.graphicsLayer.id, toReset: [] };
                var symbol = callout.textGraphic.symbol;
                originalSymbols.toReset.push({ symbol: { type: symbol.type, json: symbol.toJSON() }, graphic: callout.textGraphic });
                symbol.font.size = symbol.font.size / textScale;
                this.offsetText(symbol, textOffsetMultiplier, textScale);
                retVal.push(originalSymbols);
            }
        }
        catch (e_15_1) { e_15 = { error: e_15_1 }; }
        finally {
            try {
                if (callouts_1_1 && !callouts_1_1.done && (_a = callouts_1.return)) _a.call(callouts_1);
            }
            finally { if (e_15) throw e_15.error; }
        }
        return retVal;
    };
    PrintService.prototype.scaleSymbol = function (symbol, scale, textScale, textOffsetMultiplier) {
        switch (symbol.type) {
            case 'simple-marker':
                var smSymbol = symbol;
                if (smSymbol.size) {
                    smSymbol.size = Math.ceil(smSymbol.size * (scale * 1.25));
                }
                if (smSymbol.outline && smSymbol.outline.width) {
                    smSymbol.outline.width = Math.ceil(smSymbol.outline.width * scale);
                }
                break;
            case 'picture-marker':
                var pmSymbol = symbol.toJSON();
                if (pmSymbol.height) {
                    pmSymbol.height = Math.ceil(pmSymbol.height * scale);
                }
                if (pmSymbol.width) {
                    pmSymbol.width = Math.ceil(pmSymbol.width * scale);
                }
                break;
            case 'simple-line':
                var slSymbol = symbol;
                if (slSymbol.width) {
                    slSymbol.width = Math.ceil(slSymbol.width * scale);
                }
                break;
            case 'simple-fill':
                var sfSymbol = symbol;
                if (sfSymbol.outline && sfSymbol.outline.width) {
                    sfSymbol.outline.width = Math.ceil(sfSymbol.outline.width * scale);
                }
                break;
            case 'picture-fill': // This one may have some trouble
                var pfSymbol = symbol;
                if (pfSymbol.height) {
                    pfSymbol.height = Math.ceil(pfSymbol.height * scale);
                }
                if (pfSymbol.width) {
                    pfSymbol.width = Math.ceil(pfSymbol.width * scale);
                }
                if (pfSymbol.xscale) {
                    pfSymbol.xscale = Math.ceil(pfSymbol.xscale * scale);
                }
                if (pfSymbol.yscale) {
                    pfSymbol.yscale = Math.ceil(pfSymbol.yscale * scale);
                }
                break;
            case 'text': // May want to exclude this, as it's tied to the screen instead of the map
                var tSymbol = symbol;
                if (tSymbol.font && tSymbol.font.size) {
                    tSymbol.font.size = Math.ceil(tSymbol.font.size / textScale);
                }
                this.offsetText(tSymbol, textOffsetMultiplier, textScale);
                break;
            default:
                throw new Error('Symbol type for scaling not valid: ' + symbol.type);
        }
    };
    PrintService.prototype.offsetText = function (symbol, textOffsetMultiplier, textScale) {
        var characterMax = Math.floor(((symbol.lineWidth / textScale) / symbol.font.size) * lineWidthMultiplyer);
        var newlineRegex = new RegExp("(?![^\n]{1," + characterMax + "}$)([^\n]{1," + characterMax + "})\\s", 'g');
        symbol.text = symbol.text.replace(newlineRegex, '$1\n');
        if (symbol.yoffset < 0) {
            symbol.yoffset = (-symbol.yoffset) * textOffsetMultiplier;
        }
        else {
            symbol.yoffset = symbol.yoffset * (textOffsetMultiplier * 2);
        }
    };
    PrintService.prototype.resetDrawingLayers = function (oldValues) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_16, _a, e_17, _b, oldValues_1, oldValues_1_1, drawingLayerSymbols, _c, _d, resetItem, e_17_1, e_16_1;
            return tslib_1.__generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _e.trys.push([0, 11, 12, 13]);
                        oldValues_1 = tslib_1.__values(oldValues), oldValues_1_1 = oldValues_1.next();
                        _e.label = 1;
                    case 1:
                        if (!!oldValues_1_1.done) return [3 /*break*/, 10];
                        drawingLayerSymbols = oldValues_1_1.value;
                        _e.label = 2;
                    case 2:
                        _e.trys.push([2, 7, 8, 9]);
                        _c = tslib_1.__values(drawingLayerSymbols.toReset), _d = _c.next();
                        _e.label = 3;
                    case 3:
                        if (!!_d.done) return [3 /*break*/, 6];
                        resetItem = _d.value;
                        return [4 /*yield*/, this.setSymbol(resetItem.symbol, resetItem.graphic)];
                    case 4:
                        _e.sent(); // Maybe we don't need to wait for this to complete?
                        _e.label = 5;
                    case 5:
                        _d = _c.next();
                        return [3 /*break*/, 3];
                    case 6: return [3 /*break*/, 9];
                    case 7:
                        e_17_1 = _e.sent();
                        e_17 = { error: e_17_1 };
                        return [3 /*break*/, 9];
                    case 8:
                        try {
                            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                        }
                        finally { if (e_17) throw e_17.error; }
                        return [7 /*endfinally*/];
                    case 9:
                        oldValues_1_1 = oldValues_1.next();
                        return [3 /*break*/, 1];
                    case 10: return [3 /*break*/, 13];
                    case 11:
                        e_16_1 = _e.sent();
                        e_16 = { error: e_16_1 };
                        return [3 /*break*/, 13];
                    case 12:
                        try {
                            if (oldValues_1_1 && !oldValues_1_1.done && (_a = oldValues_1.return)) _a.call(oldValues_1);
                        }
                        finally { if (e_16) throw e_16.error; }
                        return [7 /*endfinally*/];
                    case 13: return [2 /*return*/];
                }
            });
        });
    };
    PrintService.prototype.setSymbol = function (symbolInfo, graphic) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, SimpleMarkerSymbol, PictureMarkerSymbol, SimpleLineSymbol, SimpleFillSymbol, PictureFillSymbol, TextSymbol;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = symbolInfo.type;
                        switch (_a) {
                            case 'simple-marker': return [3 /*break*/, 1];
                            case 'picture-marker': return [3 /*break*/, 3];
                            case 'simple-line': return [3 /*break*/, 5];
                            case 'simple-fill': return [3 /*break*/, 7];
                            case 'picture-fill': return [3 /*break*/, 9];
                            case 'text': return [3 /*break*/, 11];
                        }
                        return [3 /*break*/, 13];
                    case 1: return [4 /*yield*/, ESRI.SimpleMarker];
                    case 2:
                        SimpleMarkerSymbol = _b.sent();
                        graphic.symbol = SimpleMarkerSymbol.fromJSON(symbolInfo.json);
                        return [3 /*break*/, 14];
                    case 3: return [4 /*yield*/, ESRI.PictureMarker];
                    case 4:
                        PictureMarkerSymbol = _b.sent();
                        graphic.symbol = PictureMarkerSymbol.fromJSON(symbolInfo.json);
                        return [3 /*break*/, 14];
                    case 5: return [4 /*yield*/, ESRI.SimpleLine];
                    case 6:
                        SimpleLineSymbol = _b.sent();
                        graphic.symbol = SimpleLineSymbol.fromJSON(symbolInfo.json);
                        return [3 /*break*/, 14];
                    case 7: return [4 /*yield*/, ESRI.SimpleFill];
                    case 8:
                        SimpleFillSymbol = _b.sent();
                        graphic.symbol = SimpleFillSymbol.fromJSON(symbolInfo.json);
                        return [3 /*break*/, 14];
                    case 9: return [4 /*yield*/, ESRI.PictureFill];
                    case 10:
                        PictureFillSymbol = _b.sent();
                        graphic.symbol = PictureFillSymbol.fromJSON(symbolInfo.json);
                        return [3 /*break*/, 14];
                    case 11: return [4 /*yield*/, ESRI.TextSymbol];
                    case 12:
                        TextSymbol = _b.sent();
                        graphic.symbol = TextSymbol.fromJSON(symbolInfo.json);
                        return [3 /*break*/, 14];
                    case 13: throw new Error('Saved symbol type not valid: ' + symbolInfo.type);
                    case 14: return [2 /*return*/];
                }
            });
        });
    };
    /* tslint:disable:cyclomatic-complexity */
    PrintService.prototype.setupPrintExecuteInterceptor = function (layers, extent, printBasemapLayerId, routingDetailData) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var defferer, esriConfig, removeInterceptor, interceptor;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        defferer = new Deferred();
                        this.printExecutePromise = defferer.promise;
                        return [4 /*yield*/, ESRI.Config];
                    case 1:
                        esriConfig = _a.sent();
                        removeInterceptor = function (int) {
                            esriConfig.request.interceptors.splice(esriConfig.request.interceptors.indexOf(int), 1);
                            defferer.resolve();
                        };
                        interceptor = {
                            urls: [environment.apiBaseUrl + "/arcgis/print/execute"],
                            before: function (params) {
                                var e_18, _a;
                                // Fix the map extent
                                var webMap = JSON.parse(params.requestOptions.query.Web_Map_as_JSON);
                                webMap.mapOptions.extent = extent.toJSON();
                                if (routingDetailData) {
                                    webMap.layoutOptions.routingDetailData = _this.getRoutingDetailsForPrint(routingDetailData);
                                }
                                var opLayers = [];
                                if (webMap.operationalLayers && webMap.operationalLayers.length) {
                                    if (printBasemapLayerId) {
                                        var printBasemapLayer = webMap.operationalLayers.find(function (layer) { return layer.id === printBasemapLayerId; });
                                        if (printBasemapLayer && printBasemapLayer.visibleLayers) {
                                            delete printBasemapLayer.visibleLayers;
                                            delete printBasemapLayer.layers;
                                        }
                                        webMap.operationalLayers = webMap.operationalLayers.filter(function (layer) { return layer.type !== 'WebTiledLayer'; });
                                    }
                                    var previousLayer = null;
                                    var _loop_2 = function (opLayer) {
                                        var matchingLayer = layers.find(function (l) { return l.id === opLayer.id; });
                                        if (matchingLayer && matchingLayer.mapcoreProps) {
                                            opLayer.title = matchingLayer.mapcoreProps.name;
                                            if (opLayer.layers) {
                                                opLayer.layers[0].name = matchingLayer.mapcoreProps.name;
                                            }
                                        }
                                        _this.replaceClientSideOnlyLineStyles(opLayer);
                                        if (opLayer && opLayer.layers && opLayer.layers.length > 0) {
                                            //when previous and current layer are both or both not visual variables, group them together
                                            var layerHasVisualVariables = JSON.stringify(opLayer.layers).toLowerCase().indexOf('visualvariables') > -1;
                                            var preLayerHasVisualVariables = (previousLayer && previousLayer.layers) ? JSON.stringify(previousLayer.layers).toLowerCase().indexOf('visualvariables') > -1 : false;
                                            if (layerHasVisualVariables) {
                                                opLayer.url = opLayer.url.replace('/mapcore/', '/mapcorepro/');
                                            }
                                            if (previousLayer && previousLayer.layers && previousLayer.layers.length > 0 && layerHasVisualVariables === preLayerHasVisualVariables) {
                                                previousLayer.layers = opLayer.layers.concat(previousLayer.layers);
                                            }
                                            else {
                                                previousLayer = tslib_1.__assign({}, opLayer);
                                                opLayers.push(previousLayer);
                                            }
                                        }
                                        else if (_this.heatmapImageData && _this.heatmapImageData.layerid === opLayer.id) {
                                            var heatMapImageLayer = {
                                                id: opLayer.id + '_heatmap',
                                                type: 'image',
                                                title: null,
                                                minScale: 0,
                                                maxScale: 0,
                                                opacity: 1,
                                                extent: _this.heatmapImageData.extent.toJSON(),
                                                imageData: _this.heatmapImageData.imageData,
                                                urlTemplate: '',
                                                credits: ''
                                            };
                                            previousLayer = null;
                                            opLayers.push(heatMapImageLayer);
                                        }
                                        else {
                                            if (opLayer.id && opLayer.id.indexOf('mc-print-extent') < 0) {
                                                opLayers.push(opLayer);
                                            }
                                            previousLayer = null;
                                        }
                                    };
                                    try {
                                        for (var _b = tslib_1.__values(webMap.operationalLayers), _c = _b.next(); !_c.done; _c = _b.next()) {
                                            var opLayer = _c.value;
                                            _loop_2(opLayer);
                                        }
                                    }
                                    catch (e_18_1) { e_18 = { error: e_18_1 }; }
                                    finally {
                                        try {
                                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                                        }
                                        finally { if (e_18) throw e_18.error; }
                                    }
                                    webMap.operationalLayers = opLayers;
                                }
                                if (webMap.layoutOptions && webMap.layoutOptions.legendOptions && webMap.layoutOptions.legendOptions.operationalLayers && webMap.layoutOptions.legendOptions.operationalLayers.length && webMap.layoutOptions.legendOptions.operationalLayers.length > 0 && opLayers) {
                                    if (printBasemapLayerId) {
                                        webMap.layoutOptions.legendOptions.operationalLayers = webMap.layoutOptions.legendOptions.operationalLayers.filter(function (layer) { return layer.id !== printBasemapLayerId; });
                                    }
                                    webMap.layoutOptions.legendOptions.operationalLayers = [{
                                            id: 'MapcoreDynamicLayer',
                                            subLayerIds: tslib_1.__spread(webMap.layoutOptions.legendOptions.operationalLayers.map(function (x) { return x.subLayerIds; }).flat()).reverse()
                                        }];
                                }
                                params.requestOptions.query.Web_Map_as_JSON = JSON.stringify(webMap);
                                var cookieRow = document.cookie.split('; ').map(function (item) { return item.split('='); }).find(function (item) { return item[0] === 'PDAuth_token'; });
                                if (cookieRow) {
                                    var pdAuthToken = cookieRow[1];
                                    if (!params.requestOptions.headers) {
                                        params.requestOptions.headers = {
                                            'X-Auth-Token': pdAuthToken
                                        };
                                    }
                                    else {
                                        params.requestOptions.headers['X-Auth-Token'] = pdAuthToken;
                                    }
                                }
                                removeInterceptor(interceptor);
                            },
                            error: (function (er) {
                                removeInterceptor(interceptor);
                                throw (er);
                            })
                        };
                        esriConfig.request.interceptors.push(interceptor);
                        return [2 /*return*/];
                }
            });
        });
    };
    PrintService.prototype.getRoutingDetailsForPrint = function (routingDetailData) {
        var routingDetailText = [];
        if (routingDetailData.layers && routingDetailData.layers.length > 0) {
            routingDetailData.layers.forEach(function (layer) {
                var routingText = [];
                routingText.push("Layer: " + layer.layerTitle);
                routingText.push("Distance: " + layer.routingDetail.distance.toFixed(2) + " " + layer.routingDetail.unit);
                if (layer.routingDetail.directions && layer.routingDetail.directions.features && layer.routingDetail.directions.features.length > 0) {
                    layer.routingDetail.directions.features.forEach(function (feature) {
                        var directionText = feature.attributes.text;
                        if (feature.attributes.length) {
                            directionText += " - " + feature.attributes.length.toFixed(2) + " " + layer.routingDetail.unit;
                        }
                        routingText.push(directionText);
                    });
                }
                routingDetailText.push(routingText);
            });
        }
        return routingDetailText;
    };
    PrintService.ngInjectableDef = i0.defineInjectable({ factory: function PrintService_Factory() { return new PrintService(i0.inject(i1.HttpClient)); }, token: PrintService, providedIn: "root" });
    return PrintService;
}());
export { PrintService };
